import script from "./inputAndSolutionElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputAndSolutionElement.vue?vue&type=script&setup=true&lang=ts"

import "./inputAndSolutionElement.vue?vue&type=style&index=0&id=dfc15f9c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfc15f9c"]])

export default __exports__